/**
 * Product Filters
 * 
 * @since 1.0.0
 */

export default () => {
  const forms = document.querySelectorAll('.js-product-filters')
  if (forms.length < 1) return

  ;[...forms].forEach(form => {
    // Submit form whenever a filter is chosen
    const savers = form.querySelectorAll('.js-product-run-filter')

    if (savers.length > 0 ) {
      ;[...savers].forEach(saver => {
        saver.addEventListener('click', () => {
          form.submit()
        })
      }) 
    }

    // Submit form whenever a sort filter is chosen
    const sorter = form.querySelector('.js-product-run-sort-filter')

    if (sorter) {
      sorter.addEventListener('change', () => {
        form.submit()
      })
    }
  })

}


// WEBPACK FOOTER //
// ./src/js/woocommerce/ProductFilters.js